import { PaginationProps } from "antd";
import React, { useState } from "react";

const useTable = () => {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (current, pageSize) => {
    setPerPage(pageSize || 10);
  };

  return { page, setPage, onShowSizeChange, perPage };
};

export default useTable;
